import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-notes-dialog',
  imports: [CommonModule, 
            MatDialogModule, 
            MatButtonModule,
            TranslatePipe],
  templateUrl: './notes-dialog.component.html',
  styleUrl: './notes-dialog.component.scss',
})
export class NotesDialogComponent {
   constructor(private readonly dialogRef: MatDialogRef<NotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public notes: string) {}

  close(): void {
    this.dialogRef.close();
  }
}
